// ------------- Component for the news panel of the application -------------------
// ----------------------------------------------------------------------------------

// import the necessary components and styles for the panels
import { Maximize2, Minimize2 } from 'lucide-react';
import { useFullscreen } from '../contexts/FullscreenContext';
import './PanelWrapper.css';

const PanelWrapper = ({ id, className, children }) => { // create a panel component to wrap the stock chart and metrics in a panel with a fullscreen button
  const { fullscreenPanel, toggleFullscreen, headerHeight } = useFullscreen(); // get the fullscreen state and toggle function from the fullscreen context
  const isFullscreen = fullscreenPanel === id; // check if the current panel is in fullscreen mode

  return (
    <div // create a div to hold the panel content and apply the appropriate classes and styles based on the fullscreen state
      className={`${className} panel-wrapper ${isFullscreen ? 'panel-fullscreen' : ''}`}
      style={isFullscreen ? { top: `${headerHeight}px`, height: `calc(100vh - ${headerHeight}px)` } : {}} // if the panel is in fullscreen mode, set the top and height styles to fill the screen below the header
    >
      <button // create a button to toggle fullscreen mode for the panel
        className="panel-fullscreen-btn"
        onClick={() => toggleFullscreen(id)}
        title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
      >
        {isFullscreen ? <Minimize2 size={13} /> : <Maximize2 size={13} />}
      </button>
      {children}
    </div>
  );
};

export default PanelWrapper; // export the panel component
